import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import './customer-order-shipment-address-pdf.css'
import JsBarcode from 'jsbarcode'

const censorPhoneNumber = (phoneNumber) => {
  const phoneNumberDigits = phoneNumber.length
  if (phoneNumberDigits < 8) {
    return phoneNumber
  }

  const firstFourDigits = phoneNumber.substr(0, 4)
  const lastFourDigits  = phoneNumber.substr(phoneNumberDigits - 4)

  const censoredDigits = phoneNumberDigits - 8
  const censoredNumber = Array(censoredDigits).join('X')

  const censoredPhoneNumber = `${firstFourDigits}${censoredNumber}${lastFourDigits}`
  return censoredPhoneNumber
}

const propTypes = {
  shipment: PropTypes.shape({
    order: PropTypes.shape({
      number: PropTypes.string
    }),
    number                     : PropTypes.string,
    recipient_name             : PropTypes.string,
    recipient_phone            : PropTypes.string,
    destination_street_address : PropTypes.string,
    destination_kelurahan      : PropTypes.string,
    destination_kecamatan      : PropTypes.string,
    destination_kota           : PropTypes.string,
    destination_provinsi       : PropTypes.string,
    destination_kode_pos       : PropTypes.string,
    destination_note           : PropTypes.string,
    courier                    : PropTypes.string,
    courier_service_type       : PropTypes.string,
    tracking_no                : PropTypes.string
  }),
  courier: PropTypes.object
}

const defaultProps = {
  shipment: {
    order: {
      number: ''
    },
    recipient_name             : '',
    recipient_phone            : '',
    destination_street_address : '',
    destination_kelurahan      : '',
    destination_kecamatan      : '',
    destination_kota           : '',
    destination_provinsi       : '',
    destination_kode_pos       : '',
    destination_note           : '',
    courier                    : '',
    courier_service_type       : '',
    tracking_no                : ''
  },
  courier: {}
}

const CustomerOrderSipmentAddressPdf = ({ shipment, courier }) => {

  useEffect(() => {
    const tracking_no = shipment.tracking_no
    if (tracking_no) {
      JsBarcode('#barcode', tracking_no, {
        width    : 5,
        height   : 150,
        fontSize : 40
      })
    }
  }, [ shipment ])

  const shipmentPrintDetail = {
    ORDER_NUMBER: {
      label : 'No. Order',
      value : shipment.order.number
    },
    SHIPMENT_NUMBER: {
      label : 'No. Shipment',
      value : shipment.number
    },
    RECIPIENT_NAME: {
      label : 'Nama',
      value : shipment.recipient_name
    },
    RECIPIENT_PHONE: {
      label : 'Telepon',
      // value : shipment.recipient_phone
      value : censorPhoneNumber(shipment.recipient_phone)
    },
    RECIPIENT_ADDRESS: {
      label : 'Alamat',
      value : [
        shipment.destination_street_address,
        shipment.destination_kelurahan,
        shipment.destination_kecamatan,
        shipment.destination_kota,
        shipment.destination_provinsi,
        shipment.destination_kode_pos
      ]. join(', ')
    },
    NOTE: {
      label : 'Note',
      value : shipment.destination_note
    },
    SERVICE_TYPE: {
      label : 'Kurir',
      value : [
        shipment.courier,
        shipment.courier_service_type
      ].join(' - ')
    },
    NAME: {
      label : 'Nama Kurir',
      value : courier.name
    },
    LICENSE_PLATE: {
      label : 'Plat Nomor',
      value : courier.licensePlate
    }
  }

  return (
    <div id='printAddress'>
      <div
        style={{
          width  : '260mm',
          height : '345mm'
        }}
      >

        <div className='text-center mb-5'>
          <img
            src='/tinkerlust-logo.png'
            alt='tinkerlust-logo'
            width='450'
          />

          <p style={{ fontSize: 30 }}>
            { 'Jl. Sisingamangaraja No.11A, Jakarta Selatan 12120.' }
            <br />
            { 'Telp: (021) 7279 7246-47' }
          </p>
        </div>

        <table>
          {
            Object.keys(shipmentPrintDetail).map((attribute, index) => {
              const isAddress = attribute === 'RECIPIENT_ADDRESS'

              if (shipmentPrintDetail[attribute].value)
                return (
                  <tr className='mb-5' key={ `shipment-attribute-${index}` }>
                    <td
                      className={ `align-top ${isAddress && 'pb-5'}` }
                      style={{ fontSize: 35, whiteSpace: 'nowrap' }}
                    >
                      { shipmentPrintDetail[attribute].label }
                    </td>
                    <td
                      className={ `pl-3 ${isAddress && 'pb-5'}` }
                      style={{ fontSize: 35 }}
                    >
                      { `: ${shipmentPrintDetail[attribute].value}` }
                    </td>
                  </tr>
                )
            })
          }
        </table>

        <div className='d-flex justify-content-center'>
          <svg id='barcode'></svg>
        </div>

        <strong style={{ fontSize: 25 }} >{ 'Perhatikan sebelum membuka paket: ' }</strong>
        <ol style={{ fontSize: 25 }}>
          <li>{ 'Mohon videokan ketika kamu membuka paket.' }</li>
          <li>{ 'Retur hanya berlaku dalam 3 hari semenjak barang kamu terima.' }</li>
          <li>{ 'Kembalikan dengan kelengkapan seperti pada saat dikirimkan.' }</li>
          <li>{ 'Pengembalian barang luxury tanpa segel plastik yang utuh tidak dapat diproses.' }</li>
        </ol>

      </div>
    </div>
  )}

CustomerOrderSipmentAddressPdf.propTypes    = propTypes
CustomerOrderSipmentAddressPdf.defaultProps = defaultProps

export default  CustomerOrderSipmentAddressPdf
